<icc-select-box
[title]="'GARAGE_DOOR|Sterowanie' | translate"
[imageUrl]="'/files/garagedoorcontrol/' + (selectedDrive$ | async)?.img"
[description]="(selectedDrive$ | async)?.name"
[buttonText]="'INTERFACE|Zmień' | translate"
(select)="selectDrive()"
></icc-select-box>

<div class="box-form">
  <h4>{{ 'GARAGE_DOOR|Strona zamontowania napędu/przekładni:' | translate }}</h4>
  <mat-radio-group [ngModel]="(selectedDriveSide$ | async)" (ngModelChange)="selectDriveSide($event)">
      <mat-radio-button value="left">{{ 'GARAGE_DOOR|Po lewej stronie' | translate }}</mat-radio-button>
      <mat-radio-button value="right">{{ 'GARAGE_DOOR|Po prawej stronie' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>
